import { DefaultButton, PrimaryButton } from "@fluentui/react";
import React, { useContext, useState } from "react";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import "../../../styles/styles.css";
import { t } from "i18next";
import themeContext from "../../../../../context/theme/ThemeContext";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";

const defaultButtonStyles = {
  root: {
    width: "140px",
    height: "33px",
    borderRadius: "5px",
    marginLeft: "10px",
    border: "1px solid rgb(195, 196, 205)",
  },
  rootHovered: {
    backgroundColor: "black",
  },
  rootPressed: {
    backgroundColor: "black",
  },
};

const primaryButtonStyles = {
  root: {
    width: "140px",
    height: "33px",
    borderRadius: "5px",
    marginLeft: "10px",
  },
  rootHovered: {
    color: "white",
  },
  rootPressed: {
    color: "white",
  },
};

const ShowOriginal = () => {
  const { 
    setIsOutlineEnabled,
    isOutlineEnabled, 
    isHeatMapEnabled,
    setIsHeatMapEnabled,} =
    useContext(studyviewerContext);

  const {
    activeViewportIndex,
    originalImageActiveState,
    setOriginalImageActiveState,
  } = useContext(ViewportContext);

  const [disableHeatmap, setDisableHeatmap] = useState(false);
  const [disableOutline, setDisableOutline] = useState(false);

  const handleClick = () => {
    let temp = originalImageActiveState.map((state, index) => {
      console.log("orignalImage active state", state);
      if (index === activeViewportIndex) {

        if(state === false) {
          if(isOutlineEnabled) {
            setDisableOutline(true);
            setIsOutlineEnabled(false);
          } 
          if(isHeatMapEnabled) {
            setDisableHeatmap(true);
            setIsHeatMapEnabled(false);
          }
        } else {
          if(disableOutline === true) {
            setDisableOutline(false);
            setIsOutlineEnabled(true);
          }
          if(disableHeatmap === true) {
            setDisableHeatmap(false);
            setIsHeatMapEnabled(true);
          }
        }

        return !state;
      } else return state;
    });
    setOriginalImageActiveState(temp);
  };

  const buttonStyle = {
    root: {
      height: "33px",
      border: "1px solid rgb(195, 196, 205)",
    },
  };

  if (originalImageActiveState[activeViewportIndex]) {
    return (
      // <PrimaryButton
      //   text="Show Original"
      //   styles={primaryButtonStyles}
      //   onClick={handleClick}
      // />
      <CustomPrimaryButton
        active={true}
        text={t("button.show-downsize")}
        onClick={handleClick}
      />
    );
  } else {
    return (
      // <DefaultButton
      //   text="Show Original"
      //   styles={defaultButtonStyles}
      //   onClick={handleClick}
      // />
      <CustomPrimaryButton
        active={false}
        text={t("button.show-original")}
        onClick={handleClick}
      />
    );
  }
};

export default ShowOriginal;

export const CustomPrimaryButton = (props) => {
  const { getThemeColor,themeName } = useContext(themeContext);
  return (
    <>
      <div
        style={{
          width: "73px",
          marginLeft:"4px",
          background: props.active ? "rgb(0, 120, 212)" : "unset",
          border: props.active ? "1px solid transparent" :  themeName != "light"?"1px solid #C3C4CD": "1px solid rgb(41 41 41)",
        }}
        className="primay-button-topbar"
        onClick={props.onClick}
      >
        <span className="pathology-text-topbar" style={{color: props.active || themeName !== "light" ? "#FFF" : "#000"}}>{props.text}</span>
      </div>
    </>
  );
};
